import { ElementController, getData } from 'js-common';

import { PROJECT_FILTER_CONTROLLER_ID } from './constants';

// Filter value for when no particular term is selected. Keep in sync with HTML.
const DEFAULT_FILTER_TERM = 'all';

/**
 * Controller for filtering projects in list.
 */
export default class ProjectFilter extends ElementController {
  static id = PROJECT_FILTER_CONTROLLER_ID;

  /**
   * DOM loaded, initialize elements and bind events.
   */
  init() {
    this.selectListSector = this.getSingleNode('select-list-sector');
    this.selectListStatus = this.getSingleNode('select-list-status');
    this.filterItems = this.getNodes('filter-item');
    this.fallbackContent = this.getSingleNode('project-list-fallback');

    if (this.selectListSector && this.selectListStatus) {
      this.on(this.selectListSector, 'change', this.handleFilter);
      this.on(this.selectListStatus, 'change', this.handleFilter);
    }
  }

  showItem(element) {
    element.removeAttribute('hidden');
  }

  hideItem(element) {
    element.setAttribute('hidden', '');
  }

  handleFilter = () => {
    const filterTermSector = this.selectListSector.value;
    const filterTermStatus = this.selectListStatus.value;

    if (this.filterItems.length < 1) {
      return;
    }

    this.filterItems.forEach((element) => {
      const termsData = getData(element, 'filter');
      const json = JSON.parse(termsData);
      const { tags } = json;
      const { status } = json;

      if (
        tags.includes(filterTermSector) &&
        (status.includes(filterTermStatus) ||
          filterTermStatus === DEFAULT_FILTER_TERM)
      ) {
        this.showItem(element);
      } else if (
        status.includes(filterTermStatus) &&
        (tags.includes(filterTermSector) ||
          filterTermSector === DEFAULT_FILTER_TERM)
      ) {
        this.showItem(element);
      } else if (
        filterTermStatus === DEFAULT_FILTER_TERM &&
        filterTermSector === DEFAULT_FILTER_TERM
      ) {
        this.showItem(element);
      } else {
        this.hideItem(element);
      }
    });

    const visibleItems = this.filterItems.filter(
      (item) => !item.hasAttribute('hidden'),
    );
    if (visibleItems.length === 0) {
      this.showItem(this.fallbackContent);
    } else {
      this.hideItem(this.fallbackContent);
    }
  };
}
